import { sanityClient } from '../lib/sanity';

const SUP_BASE = '/images/suplemento%20de%20vitamina';
const enc = (s: string) => encodeURI(s);

export interface Product {
  id: string;
  name: string;
  price: string; // Cambiado a string para consistencia con el carrito
  category: string;
  image: string;
  detail?: string;
  description?: string;
  stock_quantity?: number;
}

// Para compatibilidad con el código existente que usa ShopItem
export type ShopItem = Product;

export const ROPA_ITEMS: Product[] = [
  { id: '1', name: 'Core Legging', price: '$88', category: 'apparel', image: '/images/ropa/VYERA_Legging_Carbon_Black_1.jpg', detail: 'Carbon Black', description: 'High-waist legging for training and everyday. Recycled fabric.' },
  { id: '2', name: 'Frequency Bra', price: '$62', category: 'apparel', image: '/images/ropa/VYERA_SportsBra_Carbon_Black.jpg', detail: 'Carbon Black', description: 'Support and comfort for movement.' },
  { id: '3', name: 'Flow Legging', price: '$88', category: 'apparel', image: '/images/ropa/VYERA_Legging_Soft_Cream.jpg', detail: 'Soft Cream', description: 'Lightweight legging. Soft Cream.' },
  { id: '4', name: 'Daily Tee', price: '$48', category: 'apparel', image: '/images/ropa/VYERA_OversizedTee_Soft_Cream.png', detail: 'Oversized', description: 'Oversized cotton tee. Soft Cream.' },
  { id: '5', name: 'Restore Tank', price: '$42', category: 'apparel', image: '/images/ropa/VYERA_LightweightLayer_Warm_Grey.jpg', detail: 'Warm Grey', description: 'Lightweight layer. Warm Grey.' },
  { id: '6', name: 'Lightweight Layer', price: '$98', category: 'apparel', image: '/images/ropa/VYERA_LightweightLayer_Deep_Burgundy.jpg', detail: 'Deep Burgundy', description: 'Lightweight layer. Deep Burgundy.' },
  { id: '7', name: 'Lightweight Carbon', price: '$98', category: 'apparel', image: '/images/ropa/VYERA_LightweightLayer_Carbon_Black.png', detail: 'Carbon Black', description: 'Lightweight layer. Carbon Black.' },
  { id: '8', name: 'Legging Warm Grey', price: '$88', category: 'apparel', image: '/images/ropa/VYERA_Legging_Warm_Grey.jpg', detail: 'Warm Grey', description: 'High-waist legging. Warm Grey.' },
  { id: '9', name: 'Oversized Black', price: '$52', category: 'apparel', image: '/images/ropa/VYERA_OversizedTee_Carbon_Black.png', detail: 'Carbon Black', description: 'Oversized cotton tee. Carbon Black.' },
  { id: '10', name: 'Sports Bra', price: '$62', category: 'apparel', image: '/images/ropa/VYERA_SportsBra_Deep_Burgundy.png', detail: 'Deep Burgundy', description: 'Support and comfort. Deep Burgundy.' },
];

export const SHOES_ITEMS: Product[] = [
  { id: 's1', name: 'Runner Black', price: '$120', category: 'shoes', image: '/images/shoes/VYERA_Zapatos_Hombre_Black.png', detail: 'Men', description: 'Minimal runner. Black. Men.' },
  { id: 's2', name: 'Runner Grey', price: '$120', category: 'shoes', image: '/images/shoes/VYERA_Zapatos_Hombre_Grey.png', detail: 'Men', description: 'Minimal runner. Grey. Men.' },
  { id: 's3', name: 'Runner Cream', price: '$120', category: 'shoes', image: '/images/shoes/VYERA_Zapatos_Mujer_Cream.png', detail: 'Women', description: 'Minimal runner. Cream. Women.' },
  { id: 's4', name: 'Runner Grey', price: '$120', category: 'shoes', image: '/images/shoes/VYERA_Zapatos_Mujer_Grey.png', detail: 'Women', description: 'Minimal runner. Grey. Women.' },
  { id: 's5', name: 'Lifestyle Black', price: '$135', category: 'shoes', image: '/images/shoes/VYERA_Zapatos_Lifestyle_Hombre_Black.jpg', detail: 'Men', description: 'Lifestyle sneaker. Black. Men.' },
  { id: 's6', name: 'Lifestyle Cream', price: '$135', category: 'shoes', image: '/images/shoes/VYERA_Zapatos_Lifestyle_Mujer_Cream.jpg', detail: 'Women', description: 'Lifestyle sneaker. Cream. Women.' },
  { id: 's7', name: 'Lifestyle Grey', price: '$135', category: 'shoes', image: '/images/shoes/VYERA_Zapatos_Lifestyle_Mujer_Grey.jpg', detail: 'Women', description: 'Lifestyle sneaker. Grey. Women.' },
  { id: 's8', name: 'Vistas Black', price: '$120', category: 'shoes', image: '/images/shoes/VYERA_Zapatos_Vistas_Black.jpg', detail: 'Detail', description: 'Minimal sneaker. Black.' },
  { id: 's9', name: 'Vistas Cream', price: '$120', category: 'shoes', image: '/images/shoes/VYERA_Zapatos_Vistas_Cream.jpg', detail: 'Detail', description: 'Minimal sneaker. Cream.' },
];

export const SUP_ITEMS: Product[] = [
  { id: 'v1', name: 'POW LEAN', price: '—', category: 'supplements', image: `${SUP_BASE}/${enc('VYERA POW LEAN - Producto Enfocado FX3 Etiqueta Correcta 1.png')}`, detail: 'Supplement', description: 'Vitamin supplement. Rhythm for your body.' },
  { id: 'v2', name: 'POW LEAN', price: '—', category: 'supplements', image: `${SUP_BASE}/${enc('VYERA POW LEAN - Producto Enfocado FX3 Etiqueta Correcta 2.png')}`, detail: 'Supplement', description: 'Vitamin supplement.' },
  { id: 'v3', name: 'POW LEAN', price: '—', category: 'supplements', image: `${SUP_BASE}/${enc('VYERA POW LEAN - Frasco Transparente Textos Corregidos (1).png')}`, detail: 'Packaging', description: 'POW LEAN packaging.' },
  { id: 'v4', name: 'POW LEAN', price: '—', category: 'supplements', image: `${SUP_BASE}/${enc('POW LEAN VYERA - Packaging Actualizado Frasco Transparente.png')}`, detail: 'Packaging', description: 'POW LEAN packaging.' },
];

export const shopProducts: Product[] = [...ROPA_ITEMS, ...SHOES_ITEMS, ...SUP_ITEMS];

export const getSanityProducts = async (): Promise<Product[]> => {
  try {
    const query = `*[_type == "product"]{
      "id": _id,
      name,
      price,
      "category": category,
      "image": image.asset->url,
      description,
      "stock": stock,
      "detail": category
    }`;
    if (!sanityClient) {
      console.warn('Sanity client not initialized, using static products');
      return shopProducts;
    }
    const products = await sanityClient.fetch(query);
    if (products && products.length > 0) {
      return products.map((p: any) => ({
        ...p,
        price: typeof p.price === 'number' ? `$${p.price.toFixed(2)}` : p.price
      }));
    }
    return shopProducts;
  } catch (error) {
    console.error('Error fetching from Sanity, falling back to static data:', error);
    return shopProducts;
  }
};

export function getAllProducts(): Product[] {
  return shopProducts;
}

export function getProductById(id: string): Product | undefined {
  return shopProducts.find((p) => p.id === id);
}

export function getProductCategory(id: string): 'apparel' | 'shoes' | 'supplements' {
  if (ROPA_ITEMS.some((p) => p.id === id)) return 'apparel';
  if (SHOES_ITEMS.some((p) => p.id === id)) return 'shoes';
  return 'supplements';
}

export const SIZES_APPAREL = ['XS', 'S', 'M', 'L', 'XL'] as const;
export const SIZES_SHOES = ['7', '8', '9', '10', '11'] as const;
export const SIZES_SUPPLEMENT = ['One Size'] as const;

export function getSuggestionsForProduct(productId: string, limit = 4): Product[] {
  const category = getProductCategory(productId);
  const pool = category === 'apparel' ? ROPA_ITEMS : category === 'shoes' ? SHOES_ITEMS : SUP_ITEMS;
  return pool.filter((p) => p.id !== productId).slice(0, limit);
}

export type Combo = {
  id: string;
  name: string;
  description?: string;
  productIds: string[];
  badge?: string;
};

export const COMBOS: Combo[] = [
  { id: 'combo-1', name: 'Train & Recover', description: 'Legging + Sports Bra', productIds: ['1', '2'], badge: 'Popular' },
  { id: 'combo-2', name: 'Full Set Carbon', description: 'Legging, Bra & Tee', productIds: ['1', '2', '9'], badge: 'Save 15%' },
  { id: 'combo-3', name: 'Runner Pack', description: 'Shoes + Lightweight Layer', productIds: ['s1', '7'], badge: 'Complete the look' },
  { id: 'combo-4', name: 'Flow Day', description: 'Flow Legging + Daily Tee', productIds: ['3', '4'], badge: 'Soft Cream' },
  { id: 'combo-5', name: 'Lifestyle Duo', description: 'Lifestyle Sneaker + Oversized Tee', productIds: ['s5', '9'], badge: 'Best value' },
];

export function getCombosForProduct(productId: string): Combo[] {
  return COMBOS.filter((c) => c.productIds.includes(productId));
}

export function getSuggestedCombos(productId: string, limit = 3): Combo[] {
  const withProduct = getCombosForProduct(productId);
  if (withProduct.length >= limit) return withProduct.slice(0, limit);
  const rest = COMBOS.filter((c) => !c.productIds.includes(productId)).slice(0, limit - withProduct.length);
  return [...withProduct, ...rest];
}
